import { mapState } from "vuex";
import AppCheckbox from "@/components/AppCheckbox";
import AppSwitch from "@/components/AppSwitch";
import AppIcon from "@/components/AppIcon";
import CurrencyValue from "@/components/tableElements/CurrencyValue.vue";
import PercentageValue from "@/components/tableElements/PercentageValue";
import { useVuelidate } from "@vuelidate/core";
import ValidateMixin from "@/mixins/ValidateMixin.vue";
export default {
  name: "PricingAndMarginDataContentRow",
  components: {
    AppCheckbox,
    AppSwitch,
    AppIcon,
    CurrencyValue,
    PercentageValue
  },
  mixins: [ValidateMixin],
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    productSegmentsList: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Boolean,
      default: false
    },
    uniqueIndex: {
      type: Number
    },
    productSegmentsList: {
      type: Array,
      default: () => []
    },
    accountProvider: {
      type: String,
      default: "Amazon Seller Central"
    },
    focusedCell: String // Receive the globally focused cell from parent
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      manualOverride: 0,
      isSearchActive: false,
      isValid: true,
      isEditing: false
    };
  },
  computed: {
    ...mapState({
      me: state => state.auth.me,
      token: state => state.auth.token,
      current_workspace: state => state.workspace.current_workspace
    }),
    image() {
      return this.item.main_image_link || '/assets/images/amazon-logo-transparent.svg';
    },
    revenueShareforProducts() {
      const val = this.item.traffic_by_asin_buy_box_percentage_28d;
      if (val == null || val === '') {
        return '0%';
      }
      return `${Math.floor(val)}%`;
    },
    calculateBuyBox() {
      const status = this.item?.buybox_status;
      const map = {
        LOSER: this.item?.buybox_price,
        LOOSER: this.item?.buybox_price,
        NO_BUYBOX: this.item?.competitive_price_threshold
      };
      const raw = map[status];
      if (raw === null || raw === undefined || raw === '') return null;
      const num = Number(raw);
      return Number.isFinite(num) ? num : null;
    },
    calculateGap() {
      const status = String(this.item?.buybox_status || '').toUpperCase().replace(/[^A-Z]/g, '_');
      if (status !== 'LOOSER' && status !== 'NO_BUYBOX') return null;
      const refRaw = status === 'LOOSER' ? this.item?.buybox_price : this.item?.competitive_price_threshold;
      if (refRaw == null) return null; // no reference → hide

      const price = +this.item?.price;
      const reference = +refRaw;
      if (!Number.isFinite(price) || !Number.isFinite(reference)) return null;
      const gap = price - reference;
      const rounded = Math.round(gap * 100) / 100;
      const abs = Math.abs(rounded);
      if (abs === 0) return null;
      const positive = rounded > 0;
      return {
        gap,
        // raw gap (if needed elsewhere)
        abs,
        // positive magnitude for <currency-value>
        sign: positive ? '+' : '−',
        // sign only for non-zero
        color: positive ? 'var(--color-semantic-red-700, #DB333B)' : 'var(--color-semantic-green-700, #22863D)'
      };
    },
    asinSku() {
      if (this.accountProvider === "Amazon Vendor Central") {
        return `${this.item.asin} - ${this.item.asin}`;
      }
      return `${this.item.asin} - ${this.item.sku}`;
    },
    formattedDaysOfInventory() {
      const days = this.item?.days_of_inventory;
      if (days == null || days === '') return '';
      return `${Math.floor(days)}D`;
    },
    computedId() {
      //console.log(`${this.item.asin || 'asin-' + this.uniqueIndex}-${this.item.sku || 'sku-' + this.uniqueIndex}`);
      return `${'asin-' + this.uniqueIndex}`;
    }
  },
  methods: {
    getCountryFlag(country_code, type = "shiny") {
      if (!country_code) return null;
      return `/assets/flags/${country_code}.png`;
    },
    isNegative(value) {
      const n = this.toNumber(value);
      return n < 0;
    },
    formatMarginRate(value) {
      const n = this.toNumber(value);
      if (n === null) return '—';
      const percent = n * 100; // convert 0.54 → 54
      let formatted = percent.toFixed(1); // keep 1 decimal initially

      // Remove trailing .0 → e.g. "54.0" → "54"
      if (formatted.endsWith('.0')) {
        formatted = formatted.slice(0, -2);
      }
      const sign = percent > 0 ? '+' : ''; // negative already has '-'
      return `${sign}${formatted}%`;
    },
    toNumber(value) {
      if (value === null || value === undefined) return null;
      if (typeof value === 'number') return value;
      const cleaned = String(value).replace('%', '').trim();
      const num = Number(cleaned);
      if (!Number.isFinite(num)) return null;

      // If num > 1, assume it's already a percent (54 → 0.54)
      return num > 1 ? num / 100 : num;
    }
  }
};